import { useTranslation } from 'react-i18next';

const CathyStory = () => {
  const { t } = useTranslation();
  
  const milestones = [
    { year: t('about.story.milestones.m1.year'), title: t('about.story.milestones.m1.title'), desc: t('about.story.milestones.m1.desc') },
    { year: t('about.story.milestones.m2.year'), title: t('about.story.milestones.m2.title'), desc: t('about.story.milestones.m2.desc') },
    { year: t('about.story.milestones.m3.year'), title: t('about.story.milestones.m3.title'), desc: t('about.story.milestones.m3.desc') },
    { year: t('about.story.milestones.m4.year'), title: t('about.story.milestones.m4.title'), desc: t('about.story.milestones.m4.desc') },
    { year: t('about.story.milestones.m5.year'), title: t('about.story.milestones.m5.title'), desc: t('about.story.milestones.m5.desc') },
  ];

  return (
    <section className="relative py-24 bg-[#030006] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_100%_50%,rgba(140,82,255,0.1)_0%,transparent_60%)]" />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left: Photo + Info */}
          <div className="flex-1 lg:sticky lg:top-28">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#8c52ff]/20 to-[#00c2ff]/10 rounded-3xl blur-2xl scale-105" />
              <div className="relative bg-white/3 border border-white/10 rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=confident%20latina%20entrepreneur%20businesswoman%20digital%20mentor%20professional%20photo%20studio%20purple%20blue%20lighting%20elegant%20modern%20background%20empowering&width=500&height=600&seq=cathy2&orientation=portrait"
                  alt={`Cathy Roldán - ${t('about.story.photoBadge')}`}
                  className="w-full h-80 md:h-96 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030006] via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h2 className="text-white font-black text-2xl">Cathy Roldán</h2>
                  <p className="text-[#8c52ff] text-sm font-semibold">{t('about.story.photoBadge')}</p>
                  <p className="text-white/50 text-xs mt-1">Smart Business Digital Solutions LLC</p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="mt-6 flex items-center gap-3 justify-center">
              {[
                { icon: 'ri-instagram-line', href: 'https://instagram.com', color: '#FF2DAA' },
                { icon: 'ri-facebook-circle-line', href: 'https://facebook.com', color: '#8c52ff' },
                { icon: 'ri-tiktok-line', href: 'https://tiktok.com', color: '#00c2ff' },
                { icon: 'ri-youtube-line', href: 'https://youtube.com', color: '#FF2DAA' },
                { icon: 'ri-linkedin-box-line', href: 'https://linkedin.com', color: '#00c2ff' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/60 hover:text-white transition-all duration-300 cursor-pointer"
                  style={{ '--hover-color': s.color } as React.CSSProperties}
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Right: Story */}
          <div className="flex-1">
            <p className="text-[#8c52ff] text-xs font-bold uppercase tracking-widest mb-4">{t('about.story.badge')}</p>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight">
              {t('about.story.title')}
              <span className="block bg-gradient-to-r from-[#8c52ff] to-[#FF2DAA] bg-clip-text text-transparent">
                {t('about.story.titleHighlight')}
              </span>
            </h2>

            <div className="space-y-5 text-white/60 text-base leading-relaxed mb-12">
              <p>{t('about.story.p1')}</p>
              <p>{t('about.story.p2')}</p>
              <p>{t('about.story.p3')}</p>
              <p>{t('about.story.p4')}</p>
            </div>

            {/* Timeline */}
            <div className="space-y-6">
              <h3 className="text-white font-bold text-xl mb-6">{t('about.story.trajectoryTitle')}</h3>
              {milestones.map((m, i) => (
                <div key={m.year} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#8c52ff] to-[#00c2ff] text-white text-xs font-black flex-shrink-0">
                      {i + 1}
                    </div>
                    {i < milestones.length - 1 && (
                      <div className="w-px flex-1 bg-gradient-to-b from-[#8c52ff]/40 to-transparent mt-2" />
                    )}
                  </div>
                  <div className="pb-6">
                    <div className="flex items-center gap-3 mb-1">
                      <span className="text-[#8c52ff] text-xs font-bold">{m.year}</span>
                      <h4 className="text-white font-bold text-base">{m.title}</h4>
                    </div>
                    <p className="text-white/50 text-sm leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CathyStory;
